import React, { useEffect, useState } from 'react';
import {
 Chart as ChartJS,
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend,
 elements
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar, Chart } from "react-chartjs-2";
import CustomeDate from 'pages/ClientDashBoard/Components/Widgets/CustomeDate';
import Drawer from 'components/Drawer';
import TopSpecialityDrugsByPMPMDrawer from '../GridData/TopSpecialityDrugsByPMPMDrawer';
ChartJS.register(
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend,
 ChartDataLabels
);
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
    CardHeader,
    Button,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import { default as ReactSelect } from "react-select";
import useAxios from 'hooks/useAxios';
const TopSpecialtyDrugsByPMPM  = ({data,searchData}) => {
const API = useAxios();
   const {dateRange, pbmPlanId, pbmGroupID,planCode, startDate, endDate,rebateflag,groupCode} = searchData;
       const [isOpen, setIsOpen] = useState(false);
         const [active, setActive] = useState('3');
       const [disabledViewButtom, setDisabledViewButtom] = useState(true);
      //  const [disabledChartFilterButton, setDisabledChartFilterButton] = useState(true);
        // const [graphClaimStatus,setGraphClaimStatus] = useState('NPC');
            const[topSpecialtyDrugsByPMPM,settopSpecialtyDrugsByPMPM]=useState([]);

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0 && data[0] != null) {
      setDisabledViewButtom(false);
      settopSpecialtyDrugsByPMPM(data);
    }
    else {
      setDisabledViewButtom(true);
      settopSpecialtyDrugsByPMPM([]);
    }
  },
    [data]);

          //     const claimStatus = [
          //      { value: 'ALL', label: 'All' },
          //      { value: 'NPC', label: 'Net Paid Claims' },
          //      { value: 'REJ', label: 'Rejected' },
          //      { value: 'REV', label: 'Reversal' }
          //  ]
          // const handleStatus = (value) => {
          //     const datavalue= []
          //      setGraphClaimStatus(value.value)
          //      getTopSpecialtyDrugByPMPM(value.value)
          //  }

           
//        const getTopSpecialtyDrugByPMPM=async()=>{
//         const  data1  = await API.get(
//  `/PBMTenant/${pbmPlanId}/PBMClientDashboard/getTopSpecialtyDrugByPMPM/${pbmGroupID}/${dateRange}/${startDate}/${endDate}/${rebateflag}/${planCode}/${groupCode}`);
//          settopSpecialtyDrugsByPMPM(data1.data);
//       }
  
  const chartData = {


  labels: topSpecialtyDrugsByPMPM?.map(item => item.drugName), 
  datasets: [
    {
      type: 'bar',
      label: 'Speciality PMPM',
      data:topSpecialtyDrugsByPMPM?.map(item => item.specialtySpend), 
      backgroundColor: '#B54DA0',
      borderColor: '#B54DA0',
      borderWidth: 1,
    },
  ],
};

const options = {
  responsive: true,
    maintainAspectRatio: false,
  indexAxis: 'y', // Set to horizontal bar chart
   barThickness: 22,
   elements:{
    bar: {
     borderWidth: 2,
       paddingLeft: 5,
    },
  },
  plugins: {
    legend: {
      position: 'bottom',
         labels: {
                        padding: 15,
                        usePointStyle: true,
                        pointStyle: 'rect',
                        color: '#707070',
                        font: {
                            weight: 'bold',
                        },
                    },
                      align: 'start',
    },
    title: {
      display: true,
     // text: 'Top 10 Specialty Drugs - By PMPM',
    },
    datalabels: {
      display:false,
      anchor: 'start',
      align: 'end',
      labels: {
        value: {
          color: '#2B3346',
        },
      },
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      grid: {
        display: false,
      },
      ticks: {
        autoSkip: false,  // Prevents the skipping of labels if they fit
      },
    },
  },
};


 const handleActive = (title) => {
        setActive(title);
    };
    const getDate = () => {
        setActive('custom')
    }
    const handleProceed = () => {
        setIsOpen(!isOpen);
    }
    const onHandleIsOpen = (hasRefresh) => {
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
    }
 return (
    <div>
      <ErrorBoundary>
          <Card className='p-3 h-100'>
                         <CardHeader className='border-0 bg-white px-0 pt-0'>
                             <Row className='align-items-center'>
                             <Col>
                              <CardTitle className="f-20 font-weight-500">Top 10 Specialty Drugs - By PMPM 
                                 <span className='qu_icon' style={{ "paddingLeft": "10px" }} data-title={"The total Plan Paid amount for the net processed, non-reversed claims per month."}>
                                    {/* <img src={QuestionIcon} style={{"width":"20px"}} /> */}
                                </span>
                              </CardTitle>
                          
                         
                             </Col>
                              <Col xs='auto' hidden={true}>
                            <Nav className='widget-tabs'>
                                <NavItem>
                                    <NavLink
                                        className={
                                            active === '3'
                                                ? 'active-tab cursor-pointer f-12'
                                                : 'cursor-pointer f-12'
                                        }
                                        onClick={() => handleActive('3')}
                                    >
                                        3 Mon
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={
                                            active === '6'
                                                ? 'active-tab cursor-pointer f-12'
                                                : 'f-12 cursor-pointer'
                                        }
                                        onClick={() => handleActive('6')}
                                    >
                                        6 Mon
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={
                                            active === '12'
                                                ? 'active-tab cursor-pointer f-12'
                                                : 'cursor-pointer f-12'
                                        }
                                        onClick={() => handleActive('12')}
                                    >
                                        1 Yr
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={
                                        active === 'custom'
                                            ? 'active-tab cursor-pointer f-12'
                                            : 'cursor-pointer f-12'
                                    }>
                                        <CustomeDate getDate={getDate} active={active} />
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Col>
                             </Row>
                                </CardHeader>
                                
            <CardBody className='dashboard-chart-body'>
              <div className='dashboard-horizontal-combochart-height'>
             <Bar  data={chartData} options={options} /></div>
              <div className="view-report">
                                     <Button
                                         color='primary'
                                         className='ms-2'
                                         onClick={handleProceed}
                           style={{ float: "right", position: "absolute", bottom: "3px", right: "30px"}}
                                         disabled={disabledViewButtom}
                                     >
                                         View Report
                                     </Button>
                                     </div>
                                             {/* <ReactSelect 
                                options={claimStatus}
                                onChange={(e) => handleStatus(e)}
                                value={
                                    claimStatus.filter(option =>
                                        option.value === graphClaimStatus)
                                }
                                className='col-4 mt-4'
                                isDisabled={disabledChartFilterButton}
                            /> */}
            </CardBody>
          </Card>
          <Drawer
                direction='end'
                title='Top Specialty Drugs-By PMPM'
                isOpen={isOpen}
                toggle={handleProceed}
                size="lg"
            >
                <TopSpecialityDrugsByPMPMDrawer searchData={searchData}  onHandleIsOpen={onHandleIsOpen}/>
            </Drawer> 
          </ErrorBoundary>
    </div>
 )
}
export default  TopSpecialtyDrugsByPMPM;